import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCompany } from '../../Redux/selecters';

// The one place that decides which client-only features are on. Call sites use
// canEditRevenuePostings() / useClientFeatures() — never compare company names themselves.

const readCompanyName = (company) => {
    try {
        const DB = localStorage.getItem('DataBase');
        const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
        const current = companies.find((comp) => comp.dataDB === DB);
        return (current?.companyName || company?.selectedCompany?.companyName || '').toLowerCase();
    } catch {
        return (company?.selectedCompany?.companyName || '').toLowerCase();
    }
};

/**
 * Revenue posting list / edit / delete exist for Jaberi only.
 * @param {object} [company] the `company` slice of the redux state (used as a fallback source of the name)
 * @returns {boolean}
 */
export const canEditRevenuePostings = (company) => readCompanyName(company).includes('jaberi');

/** Recomputes when the selected company changes. */
export const useClientFeatures = () => {
    const company = useSelector(getCompany);
    return useMemo(() => ({
        canEditRevenuePostings: canEditRevenuePostings(company),
    }), [company]);
};
